<template>
    <div>
        <el-container class="el-container">
            <el-header v-if="!isTopNav" class="headerBgColor">
                <HeaderNav></HeaderNav>
            </el-header>

            <div class="layoutConter">
                <el-aside
                    v-if="route.path !== '/index' && route.path !== '/dashboard' && !isLeftNav"
                >
                    <LeftNav></LeftNav>
                </el-aside>
                <el-main :data-route="route.name">
                    <appMain></appMain>
                </el-main>
            </div>
            <!-- <el-footer class="footer">
          <FooterNav></FooterNav>
      </el-footer> -->
        </el-container>
    </div>
</template>

<script setup name="layout">
import HeaderNav from '@/components/HeaderNav.vue'
import LeftNav from '@/components/LeftNav.vue'
import appMain from './appMain.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
import { useIndexSore } from '@/store/modules/app'
import { storeToRefs } from 'pinia'

const store = useIndexSore()
const { isLeftNav, isTopNav } = storeToRefs(store)
</script>

<style lang="scss" scoped>
.el-main[data-route='talkscripts'] {
    overflow: hidden;
}
.el-container {
    height: 100vh;
}

.headerBgColor {
    height: 100%;
}

.el-header {
    height: 66px;
    background-color: #fff;
}

.layoutConter {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    // background: linear-gradient(to right, #e6f3ff 0%, #ebfeff 100%);
}

.el-aside {
    width: 150px;
    height: 100%;
    // background: linear-gradient(to bottom, #e5f0ff 0%, #ebfeff 100%);
}

.el-main {
    height: 100%;
    padding: 15px;
    background-color: rgb(231, 245, 254);
    // background: linear-gradient(to right, #e5f0ff 0%, #ebfeff 100%);
}

.footer {
    background: linear-gradient(to right, #e5f0ff 0%, #ebfeff 100%);
}
</style>
